<template>
	<div class="body" v-loading="loading" element-loading-text="拼命加载中...">
		<div class="body-container">

			<div class="item-ctr" v-if="base">
				<div class="item-title">（一）专业基础课程</div>
				<div class="item-value">{{base}}</div>
			</div>

			<div class="item-ctr" v-if="skillList && skillList.length > 0">
				<div class="item-title item-title-table">（二）专业技能课程</div>
				<el-table :data="skillList" border stripe>
					<el-table-column label="序号" align="center" prop="index">
					</el-table-column>
					<el-table-column label="课程" align="left" prop="course">
					</el-table-column>
					<el-table-column label="典型工作任务描述" align="left" prop="content">
						<template v-slot="{ row }">
							<div class="wrap-content">{{formatTextWithLineBreaks(row.task)}}</div>
						</template>
					</el-table-column>
					<el-table-column label="主要教学内容与要求" align="left" prop="content">
						<template v-slot="{ row }">
							<div class="wrap-content">{{formatTextWithLineBreaks(row.teach)}}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div class="item-ctr" v-if="ext">
				<div class="item-title">（三）专业拓展课程</div>
				<div class="item-value">{{ext}}</div>
			</div>

			<div class="item-ctr" v-if="intro">
				<div class="item-title">说明</div>
				<div class="item-value">{{intro}}</div>
			</div>

		</div>

		<div class="action-ctr" v-if="isDone">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下载报告</el-button>
		</div>


	</div>
</template>

<script>
	import {
		toExportAbilityReport
	} from "@/api/matrix"

	import aiChatService from '@/utils/aiChat'

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				base: '',
				skillList: [],
				ext: '',
				intro: '',
				params: {
					page: 1,
					pageSize: 20
				},
				loading: true,
				currentEventSource: null,
				isDone: false
			}
		},
		created() {
			this.initPageData();
		},

		beforeDestroy() {
			// 清理资源
			if (this.currentEventSource) {
				this.currentEventSource.close();
			}
			// aiChatService.cancelRequest();
		},


		methods: {
			initPageData() {
				this.streamData();
			},

			async streamData() {
				this.id = this.$route.query.id;
				this.params['id'] = this.id;
				this.isDone = false;

				try {
					// 使用流式对话
					await aiChatService.customeStream('matrix/streamJobCourse', this.params, {
						onMessage: (chunk) => {
							// console.log('onMessage chunk', chunk)
							this.base = chunk.data.base;
							this.skillList = chunk.data.skillList;
							this.ext = chunk.data.ext;
							this.intro = chunk.data.intro;
							
							let hasData = this.loading && (this.base || this.skillList || this.ext || this.intro);
							// console.log('this.loading hasData', hasData)
							if (hasData){
								this.loading = false;
								console.log('this.loading2222222222', this.loading)
							}
						},

						onComplete: (data) => {
							console.log('对话完成onComplete:', data);
							Message({
								message: '已分析完成',
								type: 'success'
							})
						},

						onError: (error) => {
							console.log('error', error)
							this.$message.error('请求失败: ' + error);

						},

						onDone: () => {
							console.log('对话完成onDone:');
							this.isDone = true;
						},
					});

				} catch (error) {
					console.error('对话异常:', error);
				}
			},

			// 方法：格式化文本
			formatTextWithLineBreaks(text) {
				if (text){
					text = text.replace(/；/g, '\n')
				}
				return text;
			},

			clickNext() {
				toExportAbilityReport(this.params).then(res => {
					let realData = res.data;

					window.open(realData.url, '_blank')
				})
			}

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "job_course.scss";
</style>